import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ShoppingBagIcon, PlayCircleIcon } from 'lucide-react';
const modules = [{
  icon: FileTextIcon,
  title: 'The 7-Day PDF Guide',
  description: 'Your daily blueprint. Exactly what to do from the moment you wake up until you go to sleep to optimize your circadian rhythm.',
  value: 'Core Protocol'
}, {
  icon: ShoppingBagIcon,
  title: 'Anti-Inflammatory Grocery List',
  description: 'Take the guesswork out of eating. A simple, affordable list of foods that actively lower cortisol and reduce gut inflammation.',
  value: 'Nutrition'
}, {
  icon: PlayCircleIcon,
  title: 'The 15-Minute Morning Video',
  description: 'A follow-along somatic movement routine designed to flush cortisol and wake up your nervous system gently.',
  value: 'Movement'
}];
export function Modules() {
  return <section className="py-24 bg-white border-t border-cream-dark" data-id="element-81">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-82">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-83">
          <h2 className="text-3xl md:text-4xl font-semibold mb-4" data-id="element-84">
            Everything You Get
          </h2>
          <p className="text-teal-muted text-lg" data-id="element-85">
            A complete, no-fluff system designed for immediate implementation.
            Download instantly to your phone or computer.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-86">
          {modules.map((mod, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col h-full border border-cream-dark p-8 hover:border-sage/30 transition-colors duration-300" data-id="element-87">
              <div className="flex justify-between items-start mb-6" data-id="element-88">
                <div className="w-12 h-12 bg-cream flex items-center justify-center" data-id="element-89">
                  <mod.icon className="w-6 h-6 text-sage" data-id="element-90" />
                </div>
                <span className="text-xs font-medium uppercase tracking-wider text-sage bg-sage-light px-3 py-1" data-id="element-91">
                  {mod.value}
                </span>
              </div>
              <h3 className="text-xl font-medium mb-3" data-id="element-92">{mod.title}</h3>
              <p className="text-teal-muted text-sm leading-relaxed flex-grow" data-id="element-93">
                {mod.description}
              </p>
            </motion.div>)}
        </div>

        <div id="get-access" className="mt-16 text-center scroll-mt-24" data-id="element-94">
          <a href="https://floctiva.com/cart/53077592965436:1" target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center px-8 py-4 text-base font-medium text-white bg-sage hover:bg-sage-hover transition-colors duration-200 rounded-none w-full sm:w-auto" data-id="element-95">
            Get Instant Access for $6.36
          </a>
        </div>
      </div>
    </section>;
}